import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import editorReducer from './editor';
import modalReducer from './modal';

const reducers = combineReducers({
    editor: persistReducer({ key: 'editor', storage }, editorReducer),
    modal: modalReducer,
});

export default reducers;
